module.exports = __webpack_public_path__ + "static/media/deposit-icon.3602af93.svg";